import CountOfTotalButton from './CountOfTotalButton';

export default CountOfTotalButton;
